import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  logout,
  saveLastRoute,
  setPendingReauthIdentity,
  showLoginModal,
} from "./authSlice";

/**
 * REAL baseQuery (function)
 */
const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/",
  credentials: "include",

  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth?.token;

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

/**
 * Wrapper
 */
export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    const state = api.getState();

    if (!state.auth.showLoginModal) {
      api.dispatch(saveLastRoute(window.location.pathname));
    //   api.dispatch(logout());
      // TIP-511 — pin the modal to the account whose session just died. The
      // store is deliberately NOT cleared here: an expiry mid-checkout must
      // keep its in-progress state. The cross-user leak is closed instead at
      // re-login, where a changed identity purges identity-scoped storage.
      api.dispatch(setPendingReauthIdentity(state.auth?.userInfo?.email ?? null));
      api.dispatch(showLoginModal());
    }
  }

  return result;
};
